<div (click)="toggleMessageBox()" *ngIf="commonLogics.roleCtrl([6], 'checkRoleIsEqual')">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
        <path
            d="M96-672v-192h192v72H168v120H96Zm0 576v-192h72v120h120v72H96Zm576 0v-72h120v-120h72v192H672Zm120-576v-120H672v-72h192v192h-72ZM672-288h48v48h-48v-48Zm0-96h48v48h-48v-48Zm-48 48h48v48h-48v-48Zm-48 48h48v48h-48v-48Zm-48-48h48v48h-48v-48Zm96-96h48v48h-48v-48Zm-48 48h48v48h-48v-48Zm-48-48h48v48h-48v-48Zm216-312v216H528v-216h216ZM432-432v216H216v-216h216Zm0-312v216H216v-216h216Zm-48 480v-120H264v120h120Zm0-312v-120H264v120h120Zm312 0v-120H576v120h120Z" />
    </svg>
</div>
<ul class="chat-dropdown onhover-show-div" [class.active]="openMessageBox">
    <div class="row justify-content-center p-15">
        <div class="d-flex flex-column justify-content-center align-items-center">
            <div class="text-center">
                <!-- <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt=""> -->
                <qrcode [qrdata]="qrdata" [width]="290" [errorCorrectionLevel]="'M'"></qrcode>
                <span>Rider attendance QR code</span>
            </div>
        </div>
    </div>
</ul>